var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", {}, [
    _c("div", [
      _c("div", { staticClass: "login-input" }, [
        _c("input", {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.loginName,
              expression: "loginName"
            }
          ],
          attrs: {
            placeholder: "请设置登录账号，仅限字母、数字，例如 “huawei001” ",
            maxlength: "20"
          },
          domProps: { value: _vm.loginName },
          on: {
            blur: function($event) {
              return _vm.checkInput("loginName")
            },
            input: function($event) {
              if ($event.target.composing) {
                return
              }
              _vm.loginName = $event.target.value
            }
          }
        }),
        _vm._v(" "),
        _c(
          "span",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.loginNameErr,
                expression: "loginNameErr"
              }
            ],
            staticClass: "login-err"
          },
          [_vm._v("登录账号只能由字母、数字组成，且不小于8位")]
        ),
        _vm._v(" "),
        _c("span", { staticClass: "login-input-length" }, [
          _vm._v(_vm._s(_vm.loginName.length) + "/20")
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "login-input flexStart" }, [
        _c("input", {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.code,
              expression: "code"
            }
          ],
          staticStyle: { flex: "1", "margin-right": "30px" },
          attrs: { placeholder: "请输入手机验证码", maxlength: "6" },
          domProps: { value: _vm.code },
          on: {
            keyup: function($event) {
              if (
                !$event.type.indexOf("key") &&
                _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
              ) {
                return null
              }
              return _vm.login($event)
            },
            blur: function($event) {
              return _vm.checkInput("code")
            },
            input: function($event) {
              if ($event.target.composing) {
                return
              }
              _vm.code = $event.target.value
            }
          }
        }),
        _vm._v(" "),
        _c(
          "div",
          [
            _c("button-load", {
              attrs: {
                type: "primary",
                disabled: _vm.countDisabled,
                lable:
                  _vm.counter > 0 ? _vm.counter + "s 后重新获取" : "获取验证码"
              },
              on: { clickHandle: _vm.getInviteCode }
            })
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "span",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.codeErr,
                expression: "codeErr"
              }
            ],
            staticClass: "login-err"
          },
          [_vm._v("验证码不能为空")]
        ),
        _vm._v(" "),
        _c(
          "span",
          {
            staticClass: "login-input-length",
            staticStyle: { right: "156px" },
            attrs: { maxLength: "6" }
          },
          [_vm._v(_vm._s(_vm.code.length) + "/6")]
        )
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "login-input" }, [
        _c("input", {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.password,
              expression: "password"
            }
          ],
          attrs: {
            type: "password",
            placeholder: "请输入密码",
            maxlength: "20"
          },
          domProps: { value: _vm.password },
          on: {
            blur: function($event) {
              return _vm.checkInput("password")
            },
            input: function($event) {
              if ($event.target.composing) {
                return
              }
              _vm.password = $event.target.value
            }
          }
        }),
        _vm._v(" "),
        _c(
          "span",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.passwordErr,
                expression: "passwordErr"
              }
            ],
            staticClass: "login-err"
          },
          [_vm._v("字母/数字/特殊字符(~!@#$%^&*()_.)中至少两种组成，8-20位")]
        ),
        _vm._v(" "),
        _c("span", { staticClass: "login-input-length" }, [
          _vm._v(_vm._s(_vm.password.length) + "/20")
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "login-input" }, [
        _c("input", {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.confirmPswd,
              expression: "confirmPswd"
            }
          ],
          attrs: {
            type: "password",
            placeholder: "请再次输入密码",
            maxlength: "20"
          },
          domProps: { value: _vm.confirmPswd },
          on: {
            blur: function($event) {
              return _vm.checkInput("confirmPswd")
            },
            input: function($event) {
              if ($event.target.composing) {
                return
              }
              _vm.confirmPswd = $event.target.value
            }
          }
        }),
        _vm._v(" "),
        _c(
          "span",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.confirmPswdErr,
                expression: "confirmPswdErr"
              }
            ],
            staticClass: "login-err"
          },
          [
            _vm._v(
              _vm._s(
                _vm.confirmPswd.length == 0
                  ? "密码不能为空"
                  : "两次输入密码不一致"
              )
            )
          ]
        ),
        _vm._v(" "),
        _c("span", { staticClass: "login-input-length" }, [
          _vm._v(_vm._s(_vm.confirmPswd.length) + "/20")
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "login-input" }, [
        _c("input", {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.email,
              expression: "email"
            }
          ],
          attrs: { placeholder: "请输入邮箱" },
          domProps: { value: _vm.email },
          on: {
            blur: function($event) {
              return _vm.checkInput("email")
            },
            input: function($event) {
              if ($event.target.composing) {
                return
              }
              _vm.email = $event.target.value
            }
          }
        }),
        _vm._v(" "),
        _c(
          "span",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.emailErr,
                expression: "emailErr"
              }
            ],
            staticClass: "login-err"
          },
          [_vm._v("请输入正确的邮箱")]
        )
      ]),
      _vm._v(" "),
      _c(
        "span",
        {
          staticClass: "text-color-red text-size-12",
          staticStyle: { position: "absolute" }
        },
        [_vm._v(_vm._s(_vm.errMsg))]
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "login-btn-box" },
        [
          _c(
            "a-button",
            {
              staticClass: "login-btn",
              attrs: {
                loading: _vm.loadLogin,
                type: "primary",
                disabled: !_vm.checkInput()
              },
              on: { click: _vm.checkRegister }
            },
            [_vm._v("下一步")]
          ),
          _vm._v(" "),
          _c("div", { staticClass: "login-register" }, [
            _c("span", { on: { click: _vm.toRegister } }, [_vm._v("登 录")])
          ])
        ],
        1
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-422e79b2", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-422e79b2","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components-frame/register-save.vue
// module id = nWmp
// module chunks = 1